export default "__VITE_ASSET__DgpVp_L$__"